(function () {
  if (window.tmSalePageLoaded) {
    return;
  }

  window.tmSalePageLoaded = true;

  var DEFAULT_DISCOUNT_TIERS = {
    0: 0,
    1: 10,
    2: 13,
    3: 18
  };

  function formatMoney(cents) {
    var value = Math.max(0, Number(cents) || 0) / 100;

    return '₱' + value.toLocaleString('en-PH', {
      maximumFractionDigits: value % 1 === 0 ? 0 : 2,
      minimumFractionDigits: 0
    });
  }

  function parseMoneyToCents(text) {
    var clean = String(text || '').replace(/[^0-9.]/g, '');
    var value = Number(clean);

    return Number.isFinite(value) ? Math.round(value * 100) : 0;
  }

  function readNumber(value, fallback) {
    var parsed = Number(value);

    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function readPercent(value, fallback) {
    return readNumber(value, fallback);
  }

  function readQuantity(value, fallback) {
    return Math.max(1, Math.round(readNumber(value, fallback)));
  }

  function buildTierList(shell, percents) {
    var tierList = [
      {
        quantity: readQuantity(shell && shell.dataset.tmSaleTierOneQuantity, 1),
        percent: percents[1]
      },
      {
        quantity: readQuantity(shell && shell.dataset.tmSaleTierTwoQuantity, 2),
        percent: percents[2]
      },
      {
        quantity: readQuantity(shell && shell.dataset.tmSaleTierThreeQuantity, 3),
        percent: percents[3]
      }
    ];

    tierList.sort(function (a, b) {
      return a.quantity - b.quantity;
    });

    return tierList;
  }

  function getBundleConfig(shell) {
    var percents = {
      0: 0,
      1: readPercent(shell && shell.dataset.tmSaleTierOne, DEFAULT_DISCOUNT_TIERS[1]),
      2: readPercent(shell && shell.dataset.tmSaleTierTwo, DEFAULT_DISCOUNT_TIERS[2]),
      3: readPercent(shell && shell.dataset.tmSaleTierThree, DEFAULT_DISCOUNT_TIERS[3])
    };
    var tierList = buildTierList(shell, percents);

    return {
      tiers: percents,
      tierList: tierList,
      bestTier: tierList[tierList.length - 1],
      offerName: shell && shell.dataset.tmSaleOfferName ? shell.dataset.tmSaleOfferName : '7.7',
      lockedLabel: shell && shell.dataset.tmSaleLockedLabel ? shell.dataset.tmSaleLockedLabel : '7.7 Sale Offer'
    };
  }

  function percentLabel(value) {
    return value + '% OFF';
  }

  function bottleLabel(count) {
    return count === 1 ? '1 bottle' : count + ' bottles';
  }

  function getTier(count, config) {
    var tierList = config && config.tierList ? config.tierList : [
      { quantity: 1, percent: DEFAULT_DISCOUNT_TIERS[1] },
      { quantity: 2, percent: DEFAULT_DISCOUNT_TIERS[2] },
      { quantity: 3, percent: DEFAULT_DISCOUNT_TIERS[3] }
    ];
    var matched = 0;

    tierList.forEach(function (tier) {
      if (count >= tier.quantity) {
        matched = tier.percent;
      }
    });

    return matched;
  }

  function getCurrentTier(count, config) {
    var tierList = config && config.tierList ? config.tierList : [];
    var matched = null;

    tierList.forEach(function (tier) {
      if (count >= tier.quantity) {
        matched = tier;
      }
    });

    return matched;
  }

  function getNextTier(count, config) {
    var tierList = config && config.tierList ? config.tierList : [];
    var next = null;

    tierList.some(function (tier) {
      if (count < tier.quantity) {
        next = tier;
        return true;
      }

      return false;
    });

    return next;
  }

  function bestOfferCopy(config) {
    var offerName = config && config.offerName ? config.offerName + ' ' : '';

    return 'Best ' + offerName + 'offer unlocked.';
  }

  function addBottleCopy(count, tier) {
    var needed = Math.max(0, tier.quantity - count);

    if (count <= 0) {
      return 'Add ' + bottleLabel(needed) + ' to unlock ' + percentLabel(tier.percent) + '.';
    }

    return 'Add ' + needed + ' more ' + (needed === 1 ? 'bottle' : 'bottles') + ' to unlock ' + percentLabel(tier.percent) + '.';
  }

  function getContextFromButton(button) {
    var sectionRoot = button.closest('[id^="shopify-section-"]');
    var section = sectionRoot && sectionRoot.querySelector('[data-section-code="SALE-C04"]');
    var shell = sectionRoot && sectionRoot.querySelector('[data-tm-sale-f01]');

    if (!shell && sectionRoot) {
      shell = document.querySelector('[data-tm-sale-f01-root="' + sectionRoot.id + '"]');
    }

    return {
      sectionRoot: sectionRoot,
      section: section,
      shell: shell
    };
  }

  function getButtonPayload(button) {
    var priceCents = Number(button.dataset.productPriceCents) || parseMoneyToCents(button.dataset.productPrice);
    var quantity = 1;

    return {
      variantId: button.dataset.variantId || '',
      productId: button.dataset.productId || '',
      handle: button.dataset.productHandle || '',
      title: button.dataset.productTitle || 'Selected scent',
      size: button.dataset.productSize || '',
      price: button.dataset.productPrice || formatMoney(priceCents),
      priceCents: priceCents,
      image: button.dataset.productImage || '',
      available: button.dataset.variantAvailable !== 'false' && !button.disabled,
      preorder: button.dataset.variantPreorder === 'true',
      preorderCartValue: button.dataset.preorderCartValue || '',
      quantity: quantity
    };
  }

  function isBundleButtonAvailable(button) {
    return !!button && button.dataset.variantAvailable !== 'false' && !button.disabled;
  }

  function setButtonState(button, selected) {
    if (!button.dataset.tmSaleDefaultLabel) {
      button.dataset.tmSaleDefaultLabel = button.textContent.trim() || 'ADD TO ROTATION';
    }

    if (button.dataset.variantAvailable === 'false') {
      button.classList.remove('tm-sale-f01__added');
      button.classList.add('is-sold-out');
      button.classList.remove('is-preorder');
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-disabled', 'true');
      button.disabled = true;
      button.textContent = button.dataset.soldOutLabel || 'SOLD OUT';
      return;
    }

    button.classList.remove('is-sold-out');
    button.classList.toggle('is-preorder', button.dataset.variantPreorder === 'true');
    button.removeAttribute('aria-disabled');
    button.disabled = false;
    button.classList.toggle('tm-sale-f01__added', selected);
    button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    button.textContent = selected ? 'ADDED' : button.dataset.variantPreorder === 'true' ? button.dataset.preorderButtonLabel || button.dataset.tmSaleDefaultLabel : button.dataset.tmSaleDefaultLabel;
  }

  function escapeText(value) {
    return String(value || '');
  }

  function getCartAddRoute() {
    return window.theme && window.theme.routes && window.theme.routes.cartAdd ? window.theme.routes.cartAdd : '/cart/add.js';
  }

  function notifyNativeCartAdded(responseData, addToCartButton) {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product: responseData,
        addToCartBtn: addToCartButton || null
      }
    }));
  }

  function initNativeProductForms() {
    if (!window.theme || typeof window.theme.AjaxProduct !== 'function') {
      return;
    }

    document.querySelectorAll('[data-sale-page="summer-collection-55-sale"] .tm-sale-direct-form').forEach(function (form) {
      if (form.dataset.tmSaleAjaxProductReady === 'true') {
        return;
      }

      form.dataset.tmSaleAjaxProductReady = 'true';
      new window.theme.AjaxProduct(form);
    });
  }

  function addItemsToNativeCart(items, addToCartButton) {
    return fetch(getCartAddRoute(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function (responseData) {
        notifyNativeCartAdded(responseData, addToCartButton);
        return responseData;
      });
  }

  function initBundleDrawer(shell) {
    if (!shell || shell.dataset.tmSaleF01Ready === 'true') {
      return;
    }

    shell.dataset.tmSaleF01Ready = 'true';

    var sectionRoot = shell.closest('[id^="shopify-section-"]');
    if (sectionRoot && sectionRoot.id) {
      shell.dataset.tmSaleF01Root = sectionRoot.id;
    }

    if (shell.parentElement !== document.body) {
      document.body.appendChild(shell);
    }

    var drawer = shell.querySelector('[data-tm-sale-bundle-drawer]');
    var sticky = shell.querySelector('[data-tm-sale-bundle-sticky]');
    var closeButtons = shell.querySelectorAll('[data-tm-sale-bundle-close]');
    var cta = shell.querySelector('[data-tm-sale-bundle-cta]');
    var firstCloseButton = closeButtons.length ? closeButtons[0] : null;
    var lastDrawerTrigger = null;
    var state = {
      items: [],
      isOpen: false,
      isSubmitting: false,
      cartStatus: 'idle',
      cartError: ''
    };
    var bundleConfig = getBundleConfig(shell);

    if (drawer && !drawer.hasAttribute('tabindex')) {
      drawer.setAttribute('tabindex', '-1');
    }

    function countItems() {
      return state.items.reduce(function (total, item) {
        return total + item.quantity;
      }, 0);
    }

    function subtotalCents() {
      return state.items.reduce(function (total, item) {
        return total + item.priceCents * item.quantity;
      }, 0);
    }

    function discountSavingsCents(subtotal, tier) {
      return Math.round(subtotal * (tier / 100));
    }

    function totalAfterDiscountCents(subtotal, tier) {
      return Math.max(0, subtotal - discountSavingsCents(subtotal, tier));
    }

    function findItem(variantId) {
      return state.items.find(function (item) {
        return item.variantId === variantId;
      });
    }

    function progressWidth(count) {
      if (count <= 0) return '0%';
      return Math.min(100, Math.round((count / bundleConfig.bestTier.quantity) * 100)) + '%';
    }

    function statusCopy(count) {
      var currentTier = getCurrentTier(count, bundleConfig);
      var nextTier = getNextTier(count, bundleConfig);

      if (count <= 0) return 'Choose your first scent to start your parfum rotation.';
      if (!currentTier && nextTier) return addBottleCopy(count, nextTier);
      if (currentTier && nextTier) return percentLabel(currentTier.percent) + ' unlocked. ' + addBottleCopy(count, nextTier);
      return bestOfferCopy(bundleConfig) + ' ' + percentLabel(bundleConfig.bestTier.percent) + ' included.';
    }

    function supportCopy(count) {
      var nextTier = getNextTier(count, bundleConfig);

      if (nextTier) return addBottleCopy(count, nextTier);
      return bestOfferCopy(bundleConfig);
    }

    function ctaCopy(count) {
      var tier = getTier(count, bundleConfig);

      if (count <= 0) return 'Add Bottle';
      if (state.isSubmitting) return 'Adding Rotation...';
      if (state.cartStatus === 'added') return 'Added to Cart';
      if (state.cartStatus === 'error') return 'Try Again';
      return 'Add ' + bottleLabel(count) + (tier > 0 ? ' • ' + percentLabel(tier) : '');
    }

    function visibleSupportCopy(count) {
      if (state.cartStatus === 'added') return 'Rotation added to cart.';
      if (state.cartStatus === 'error') return state.cartError || 'We could not add the rotation. Please try again.';

      return supportCopy(count);
    }

    function stickyCopy(count, subtotal, tier) {
      var totalText = formatMoney(totalAfterDiscountCents(subtotal, tier));
      var tierText = percentLabel(tier);
      var bottleText = bottleLabel(count);
      var nextTier = getNextTier(count, bundleConfig);

      if (!tier && nextTier) {
        return {
          main: 'Total ' + totalText,
          sub: bottleText + ' • ' + addBottleCopy(count, nextTier)
        };
      }

      if (nextTier) {
        return {
          main: 'Total ' + totalText,
          sub: bottleText + ' • ' + tierText + ' • ' + addBottleCopy(count, nextTier)
        };
      }

      return {
        main: 'Total ' + totalText,
        sub: bottleText + ' • ' + tierText
      };
    }

    function perkValue(count) {
      return 0;
    }

    function focusElement(element) {
      if (!element || typeof element.focus !== 'function') return;

      try {
        element.focus({ preventScroll: true });
      } catch (error) {
        element.focus();
      }
    }

    function openDrawer(trigger) {
      if (!drawer) return;
      if (trigger && typeof trigger.focus === 'function') {
        lastDrawerTrigger = trigger;
      } else if (document.activeElement && document.activeElement !== document.body && typeof document.activeElement.focus === 'function') {
        lastDrawerTrigger = document.activeElement;
      }
      if (state.cartStatus === 'added') {
        state.cartStatus = 'idle';
        state.cartError = '';
      }
      state.isOpen = true;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');

      window.requestAnimationFrame(function () {
        if (!state.isOpen) return;
        focusElement(firstCloseButton || drawer);
      });
    }

    function closeDrawer(options) {
      if (!drawer) return;
      options = options || {};
      state.isOpen = false;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');

      if (options.returnFocus !== false && lastDrawerTrigger && document.contains(lastDrawerTrigger)) {
        focusElement(lastDrawerTrigger);
      }

      lastDrawerTrigger = null;
    }

    function renderSelectedItems(row) {
      row.replaceChildren();

      if (!state.items.length) {
        var empty = document.createElement('p');
        empty.className = 'tm-sale-f01__empty';
        empty.textContent = 'Choose your first scent to start your rotation.';
        row.appendChild(empty);
        return;
      }

      state.items.forEach(function (item) {
        var tile = document.createElement('article');
        tile.className = 'tm-sale-f01__tile';

        var media = document.createElement('div');
        media.className = 'tm-sale-f01__tile-image';

        if (item.image) {
          var image = document.createElement('img');
          image.alt = item.title;
          image.loading = 'lazy';
          image.src = item.image;
          media.appendChild(image);
        }

        var title = document.createElement('p');
        title.className = 'tm-sale-f01__tile-title';
        title.textContent = escapeText(item.title);

        var priceText = item.price || (item.priceCents > 0 ? formatMoney(item.priceCents) : '');
        var meta = document.createElement('p');
        meta.className = 'tm-sale-f01__tile-meta';
        meta.textContent = [item.size, priceText].filter(Boolean).map(escapeText).join(' • ');

        var remove = document.createElement('button');
        remove.className = 'tm-sale-f01__tile-remove';
        remove.type = 'button';
        remove.dataset.tmSaleRemoveVariant = item.variantId;
        remove.textContent = 'Remove';
        remove.setAttribute('aria-label', 'Remove ' + item.title + ' from rotation');

        tile.appendChild(media);

        if (item.quantity > 1) {
          var qty = document.createElement('span');
          qty.className = 'tm-sale-f01__tile-qty';
          qty.textContent = 'x' + item.quantity;
          tile.appendChild(qty);
        }

        tile.appendChild(title);
        tile.appendChild(meta);
        tile.appendChild(remove);
        row.appendChild(tile);
      });
    }

    function syncButtons() {
      if (!sectionRoot) return;
      var selectedVariants = state.items.map(function (item) {
        return item.variantId;
      });

      sectionRoot.querySelectorAll('[data-c04-add-to-bundle]').forEach(function (button) {
        setButtonState(button, selectedVariants.indexOf(button.dataset.variantId || '') !== -1);
      });
    }

    function updateRewards(count) {
      var shipping = shell.querySelector('[data-tm-sale-reward="shipping"]');
      var shippingLabel = shell.querySelector('[data-tm-sale-shipping-label]');
      var shippingCopy = shell.querySelector('[data-tm-sale-shipping-copy]');
      var shippingState = shipping && shipping.querySelector('[data-tm-sale-reward-state]');
      var bestTier = bundleConfig.bestTier;

      if (shipping) shipping.classList.toggle('is-unlocked', count >= bestTier.quantity);
      if (shippingState) shippingState.textContent = count >= bestTier.quantity ? 'Unlocked' : 'Locked';

      if (shippingLabel) shippingLabel.textContent = count >= bestTier.quantity ? percentLabel(bestTier.percent) + ' Unlocked' : bundleConfig.lockedLabel;
      if (shippingCopy) shippingCopy.textContent = count >= bestTier.quantity ? bestOfferCopy(bundleConfig).replace('offer', 'bottle tier') : 'Buy ' + bottleLabel(bestTier.quantity) + ' to unlock ' + percentLabel(bestTier.percent) + '.';
    }

    function cartItemsPayload() {
      return state.items.map(function (item) {
        var lineItem = {
          id: Number(item.variantId) || item.variantId,
          quantity: item.quantity
        };

        if (item.preorder && item.preorderCartValue) {
          lineItem.properties = {
            Preorder: item.preorderCartValue
          };
        }

        return lineItem;
      });
    }

    function addBundleToCart() {
      var items = cartItemsPayload();

      if (!items.length || state.isSubmitting) {
        return Promise.resolve();
      }

      state.isSubmitting = true;
      state.cartStatus = 'idle';
      state.cartError = '';
      render();

      return addItemsToNativeCart(items, cta)
        .then(function (responseData) {
          state.cartStatus = 'added';
          closeDrawer({ returnFocus: false });
          window.dispatchEvent(new CustomEvent('tm:bundle-cart-added', {
            detail: {
              checkpoint: 'SALE-F01-1',
              response: responseData,
              itemCount: countItems(),
              discountTier: getTier(countItems(), bundleConfig),
              items: state.items.slice()
            }
          }));
        })
        .catch(function (error) {
          state.cartStatus = 'error';
          state.cartError = error && (error.description || error.message) ? error.description || error.message : 'We could not add the rotation. Please try again.';
          console.warn('[TM Bundle] Bundle cart add failed.', error);
        })
        .finally(function () {
          state.isSubmitting = false;
          render();
        });
    }

    function updateSummary(count, subtotal, tier) {
      var discountSavings = discountSavingsCents(subtotal, tier);
      var totalAfterDiscount = totalAfterDiscountCents(subtotal, tier);
      var perks = perkValue(count);
      var estimatedSavings = discountSavings + perks;
      var subtotalText = formatMoney(subtotal);
      var tierText = percentLabel(tier);
      var totalText = formatMoney(totalAfterDiscount);
      var perksText = perks > 0 ? formatMoney(perks) + ' perks unlocked' : formatMoney(perks) + ' value';
      var savingsText = formatMoney(estimatedSavings);
      var subtotalNode = shell.querySelector('[data-tm-sale-subtotal]');
      var discountNode = shell.querySelector('[data-tm-sale-discount]');
      var totalNode = shell.querySelector('[data-tm-sale-total-after-discount]');
      var perksNode = shell.querySelector('[data-tm-sale-perks]');
      var savingsNode = shell.querySelector('[data-tm-sale-savings]');
      var mobileSummary = shell.querySelector('[data-tm-sale-summary-mobile]');

      if (subtotalNode) subtotalNode.textContent = subtotalText;
      if (discountNode) discountNode.textContent = tierText;
      if (totalNode) totalNode.textContent = totalText;
      if (perksNode) perksNode.textContent = perksText;
      if (savingsNode) savingsNode.textContent = savingsText;
      if (mobileSummary) {
        mobileSummary.textContent = 'Subtotal ' + subtotalText + ' • Total ' + totalText + ' after ' + tierText + '';
      }
    }

    function render() {
      var count = countItems();
      var subtotal = subtotalCents();
      var tier = getTier(count, bundleConfig);
      var progressFill = shell.querySelector('[data-tm-sale-progress-fill]');
      var status = shell.querySelector('[data-tm-sale-bundle-status]');
      var support = shell.querySelector('[data-tm-sale-bundle-support]');
      var countNode = shell.querySelector('[data-tm-sale-bundle-count]');
      var row = shell.querySelector('[data-tm-sale-selected-row]');

      shell.hidden = count <= 0;

      if (count <= 0) {
        closeDrawer({ returnFocus: false });
      }

      if (progressFill) progressFill.style.width = progressWidth(count);
      if (status) status.textContent = statusCopy(count);
      if (support) support.textContent = visibleSupportCopy(count);
      if (countNode) countNode.textContent = String(count);
      if (cta) {
        cta.textContent = ctaCopy(count);
        cta.disabled = count <= 0 || state.isSubmitting;
      }

      shell.querySelectorAll('[data-tm-sale-milestone]').forEach(function (milestone) {
        var milestoneNumber = Number(milestone.dataset.tmSaleMilestone);
        milestone.classList.toggle('is-active', count >= milestoneNumber);
      });

      if (row) renderSelectedItems(row);
      updateRewards(count);
      updateSummary(count, subtotal, tier);

      if (sticky) {
        if (count > 0 && !state.isOpen) {
          var stickyText = stickyCopy(count, subtotal, tier);
          var stickyMain = sticky.querySelector('[data-tm-sale-sticky-main]');
          var stickySub = sticky.querySelector('[data-tm-sale-sticky-sub]');
          sticky.hidden = false;
          if (stickyMain) stickyMain.textContent = stickyText.main;
          if (stickySub) stickySub.textContent = stickyText.sub;
        } else {
          sticky.hidden = true;
        }
      }

      syncButtons();
    }

    function addItem(payload, openAfterAdd, trigger) {
      if (!payload.variantId || payload.available === false) {
        return;
      }

      var item = findItem(payload.variantId);

      if (item) {
        item.quantity += 1;
      } else {
        state.items.push(payload);
      }

      state.cartStatus = 'idle';
      state.cartError = '';

      if (openAfterAdd) {
        openDrawer(trigger);
      }

      render();

      window.dispatchEvent(
        new CustomEvent('tm:bundle-added', {
          detail: {
            productId: payload.productId,
            variantId: payload.variantId,
            title: payload.title,
            price: payload.priceCents,
            quantity: item ? item.quantity : payload.quantity,
            checkpoint: 'SALE-F01-1'
          }
        })
      );
    }

    shell.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-tm-sale-remove-variant]');

      if (remove) {
        state.items = state.items.filter(function (item) {
          return item.variantId !== remove.dataset.tmSaleRemoveVariant;
        });
        state.cartStatus = 'idle';
        state.cartError = '';
        render();
      }
    });

    if (sticky) {
      sticky.addEventListener('click', function () {
        openDrawer(sticky);
        render();
      });
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        closeDrawer();
        render();
      });
    });

    if (cta) {
      cta.addEventListener('click', function () {
        window.dispatchEvent(
          new CustomEvent('tm:bundle-cta-clicked', {
            detail: {
              checkpoint: 'SALE-F01-1',
              itemCount: countItems(),
              discountTier: getTier(countItems(), bundleConfig),
              items: state.items.slice()
            }
          })
        );

        addBundleToCart();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !state.isOpen) {
        return;
      }

      event.preventDefault();
      closeDrawer();
      render();
    });

    shell.tmSaleAddBundleItem = addItem;
    shell.tmSaleRender = render;
    render();
  }

  function initBundleDrawers() {
    document.querySelectorAll('[data-tm-sale-f01]').forEach(initBundleDrawer);
  }

  function handleBundleAdd(event) {
    var button = event.target.closest('[data-c04-add-to-bundle]');

    if (!button) {
      return;
    }

    var context = getContextFromButton(button);

    if (!context.shell) {
      return;
    }

    event.preventDefault();

    if (!isBundleButtonAvailable(button)) {
      setButtonState(button, false);
      return;
    }

    initBundleDrawer(context.shell);

    var payload = getButtonPayload(button);
    var openAfterAdd = !button.closest('[data-tm-c04-modal]');

    context.shell.tmSaleAddBundleItem(payload, openAfterAdd, button);
  }

  function initSalePageShell() {
    var sections = document.querySelectorAll('[data-sale-page="summer-collection-55-sale"]');

    if (!sections.length) {
      return;
    }

    document.documentElement.classList.add('tm-sale-page-active');

    sections.forEach(function (section) {
      section.setAttribute('data-sale-shell-ready', 'true');
    });

    window.dispatchEvent(
      new CustomEvent('tm:sale-page:ready', {
        detail: {
          page: 'summer-collection-55-sale',
          sectionCount: sections.length
        }
      })
    );

    initNativeProductForms();
    initBundleDrawers();
  }

  function cleanupBundleDrawersForSection(sectionElement) {
    if (!sectionElement || !sectionElement.id) {
      return;
    }

    document.querySelectorAll('[data-tm-sale-f01-root="' + sectionElement.id + '"]').forEach(function (shell) {
      if (shell.parentElement === document.body) {
        shell.remove();
      }
    });
  }

  document.addEventListener('click', handleBundleAdd);

  document.addEventListener('shopify:section:unload', function (event) {
    cleanupBundleDrawersForSection(event.target);
  });

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(initSalePageShell, 0);
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-tm-c04-size-select], [data-tm-c04-modal-size-select]')) {
      return;
    }

    window.setTimeout(function () {
      document.querySelectorAll('[data-tm-sale-f01]').forEach(function (shell) {
        if (shell.dataset.tmSaleF01Ready === 'true' && typeof shell.tmSaleRender === 'function') {
          shell.tmSaleRender();
        }
      });
    }, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSalePageShell, { once: true });
  } else {
    initSalePageShell();
  }
})();
